export const PATHS = {
    SIGN_IN: "/sign-in",
    TICKETS: "/",
    TICKET_CREATE: "/tickets/new",
    TICKET_DETAIL: "/tickets/:id",
    ADMIN_DASHBOARD: "/admin",
    ADMIN_USERS: "/admin/users",
};
